"use client";

import { createContext, useContext, useMemo } from "react";

import type { ReactNode } from "react";

// Define the shape of our configuration
interface EnvConfig {
	isLoaded: boolean;
	hasError: boolean;
}

// Create the context with a default value
const ConfigContext = createContext<EnvConfig>({
	isLoaded: false,
	hasError: false,
});

// Hook to use the config
export function useConfig() {
	return useContext(ConfigContext);
}

// Provider component
export function ConfigProvider({ children }: { children: ReactNode }) {
	const config = useMemo<EnvConfig>(
		() => ({
			isLoaded: true,
			hasError: false,
		}),
		[],
	);

	return (
		<ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
	);
}
